import React from 'react';
import { IIssue } from 'common/module_interface/RiskManagement/issues/Issues.interface';
import { RemediationPanel } from '../../../../DrawerPanels/RemediationPanel/RemediationPanel';

export const IssueRemediationPanel: React.FC<{ issue: IIssue }> = ({ issue }) => {
    return <RemediationPanel remediation={issue.remediation} />;
};
